/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// react-router-dom components
import { Link, useNavigate } from "react-router-dom"

// @mui material components
import Card from "@mui/material/Card"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDInput from "components/MDInput"
import MDButton from "components/MDButton"

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout"

// Images
import bgImage from "assets/images/bg-reset-cover.jpeg"
import { useEffect, useState } from "react"
import { Dialog, Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import MDSnackbar from "components/MDSnackbar"

import * as authService from "../../../services/auth/auth.service"

function Cover() {
  const { control, handleSubmit, watch } = useForm()
  const queryParams = new URLSearchParams(window.location.search)
  const token = queryParams.get("token")
  const [isNotValidToken, setNotIsValidToken] = useState(true)
  const navigate = useNavigate()
  const [snackbarObject, setSnackbarObject] = useState({
    open: false,
    title: "",
    content: "",
    color: "primary",
    icon: "",
  })

  const checkTokenExpiration = async () => {
    const payload = {
      resetToken: token,
    }

    const result = await authService.checkPasswordTokenService(payload)
    if (result?.data && result?.data.validToken) {
      setNotIsValidToken(false)
    } else {
      setNotIsValidToken(true)
    }
  }
  useEffect(() => {
    if (token) {
      checkTokenExpiration()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  const resetPassword = async (body) => {
    const payload = {
      newPassword: body.password,
      resetToken: token,
    }
    try {
      const result = await authService.resetPasswordService(payload)
      if (result) {
        if (result.status === 200) {
          navigate("sign-in")
        }
      }
      if (result && result.response) {
        if (result.response.status === 400) {
          handleOpenSnackbar(
            "error",
            "Token invalide ou expiré!",
            "Retour à la page mot de passe oublié pour envoyer le token",
            "error"
          )
        }
      }
    } catch (error) {
      // console.log("error ====>", error)
    }
  }

  // Handle open snackbar
  const handleOpenSnackbar = (status, title, content, icon) => {
    setSnackbarObject({
      ...snackbarObject,
      title,
      open: true,
      content,
      color: status,
      icon,
    })
  }

  // Handle close snackbar
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    setSnackbarObject({
      ...snackbarObject,
      open: false,
    })
  }

  return (
    <CoverLayout coverHeight="50vh" image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Réinitialiser le mot de passe
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            onSubmit={handleSubmit(resetPassword)}
            textAlign="center"
            noValidate
            autoComplete="off"
          >
            <MDBox mb={4}>
              <Controller
                control={control}
                name="password"
                defaultValue=""
                rules={{
                  required: {
                    value: true,
                    message: "Le champ mot de passe est obligatoire",
                  },
                }}
                render={({ field: { ref, ...field }, fieldState: { error } }) => (
                  <MDInput
                    type="password"
                    label="Mot de passe"
                    variant="standard"
                    fullWidth
                    error={Boolean(error)}
                    focused={Boolean(error)}
                    helperText={error && error.message}
                    {...field}
                  />
                )}
              />
            </MDBox>
            <MDBox mb={4}>
              <Controller
                control={control}
                name="confirmPassword"
                defaultValue=""
                rules={{
                  required: {
                    value: true,
                    message: "Le champ Confirmez le mot de passe est obligatoire",
                  },
                  validate: (value) =>
                    value === watch("password") || "Le mot de passe de confirmation ne correspond pas au mot de passe",
                }}
                render={({ field: { ref, ...field }, fieldState: { error } }) => (
                  <MDInput
                    type="password"
                    label="Confirmez le mot de passe"
                    variant="standard"
                    fullWidth
                    error={Boolean(error)}
                    focused={Boolean(error)}
                    helperText={error && error.message}
                    {...field}
                  />
                )}
              />
            </MDBox>
            <MDBox mt={6} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth>
                Réinitialiser
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                <MDTypography
                  component={Link}
                  to="/forget-password"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                  onClick={() => navigate("forget-password")}
                >
                  Retour à la page mot de passe oublié
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <Dialog open={isNotValidToken}>
        <DialogTitle id="alert-dialog-title">Vérification de Token</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Token invalide ou expiré! Retour à la page mot de passe oublié pour envoyer le token
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => navigate("/forget-password")}>Retour</Button>
        </DialogActions>
      </Dialog>
      <MDSnackbar
        color={snackbarObject.color}
        icon={snackbarObject.icon}
        title={snackbarObject.title}
        content={snackbarObject.content}
        open={snackbarObject.open}
        close={handleCloseSnackbar}
        dateTime=""
      />
    </CoverLayout>
  )
}

export default Cover
